import React, { useState, useCallback } from 'react';
import { FormTriggerSourceData } from '@decisions/server/Decisions/Silverlight/UI/Forms';
import { Checkbox } from '../../inputs/Checkbox';
import { FormTriggerType } from '@decisions/server/DecisionsFramework/ComponentData/FormTriggerType';
import classNames from 'classnames';
import { PRIMARY_CLASS } from './FormTriggerDataEditorConstants';
import { getStoredSvgImageInfoUrl } from 'utils/ImageUtils';

export interface IFormTriggerDataEditorItemOptions {
  item: FormTriggerSourceData;
  id: string;
  changeHandler: (value: FormTriggerType, componentName: string) => void;
  isSelected: (value: FormTriggerType, componentName: string) => boolean;
}

const getTriggersClass = (isCollapsed: boolean) => {
  return classNames(`${PRIMARY_CLASS}__all-triggers`, {
    [`${PRIMARY_CLASS}__all-triggers--collapsed`]: isCollapsed,
  });
};

const getNodeClass = (isSelected: boolean) => {
  return classNames(`${PRIMARY_CLASS}__node`, {
    [`${PRIMARY_CLASS}__node--selected`]: isSelected,
  });
};

export function FormTriggerDataEditorItem({ item, id, changeHandler, isSelected }: IFormTriggerDataEditorItemOptions) {
  const isAnyEventSelected = item.Events?.find(ev => isSelected(ev, item.ComponentName)) != null;

  const [isCollapsed, setIsCollapsed] = useState<boolean>(!isAnyEventSelected);

  const collapseHandler = () => {
    setIsCollapsed(!isCollapsed);
  };

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      changeHandler(parseInt(e.target.value) as FormTriggerType, item.ComponentName);
    },
    [changeHandler, item]
  );

  return (
    <div className={getNodeClass(isAnyEventSelected)}>
      <div className={`${PRIMARY_CLASS}__control-details`} onClick={collapseHandler}>
        <div className={`${PRIMARY_CLASS}__control-info`}>
          <div className={`${PRIMARY_CLASS}__control-name-holder`}>
            <span className={`${PRIMARY_CLASS}__control-name`}>{item.ComponentName}</span>
            {item.Events?.length > 0 && (
              <span className={`${PRIMARY_CLASS}__items-info`}>
                ({item.Events.filter(ev => isSelected(ev, item.ComponentName)).length} / {item.Events.length})
              </span>
            )}
          </div>
          {item.Description && <span className={`${PRIMARY_CLASS}__control-description`}>[{item.Description}]</span>}
        </div>
        <div className={`${PRIMARY_CLASS}__control-icon-holder`}>
          <img
            className={`${PRIMARY_CLASS}__control-icon`}
            src={getStoredSvgImageInfoUrl(item.DefaultImage)}
            alt={item.ComponentName}
          />
        </div>
      </div>
      <div className={getTriggersClass(isCollapsed)}>
        {item.Events &&
          item.Events.map(ev => (
            <Checkbox
              key={FormTriggerType[ev]}
              id={`${id}-${item.ComponentName}-${FormTriggerType[ev]}`}
              label={FormTriggerType[ev]}
              value={ev}
              name={item.ComponentName}
              onChange={onChange}
              checked={isSelected(ev, item.ComponentName)}
              grouped
            />
          ))}
      </div>
    </div>
  );
}
